<template>
    <div :class="className" :keyId="keyId" v-if="list.length" :data-spm="spm" data-spm-type="all">
        <slot>
            <div v-for="item in list">
                <div class="mHead">
                    <h3 class="l-title">{{item.activityName}}</h3>
                </div>
                <div :id="item.autoId" class="temID">
                    <div class="mBody">
                        <template v-for="obj in item.data">
                            <a class="l-item mui-clearfix" :href="obj.link" :data-spm="obj.id">
                                <article>
                                    <span class="top" :class="obj.topCss"></span>
                                    <span class="l-img">
                                        <img :alt="obj.goodsName" :src="obj._centerPic">
                                        <label v-if="obj.label">{{obj.label}}</label>
                                    </span>
                                    <span class="l-wrap">
                                        <span class="l-title">{{obj.goodsName}}</span>
                                        <span class="l-minPrice">
                                            <span v-html="obj.priceHtml"></span>
                                        </span>
                                        <span class="l-btn"></span>
                                    </span>
                                    <span class="l-cover" :class="obj.coverCss"><b>抢光了</b></span>
                                </article>
                            </a>
                        </template>
                        <template v-if="item.linkUrl">
                            <a class="l-item mui-clearfix l-more" :href="item.linkUrl"data-spm="more">
                                <article>
                                    <span class="top"></span>
                                    <span class="l-img">
                                        <img src="../assets/img/more.png">
                                    </span>
                                </article>
                            </a>
                        </template>
                    </div>
                </div>
            </div>
        </slot>
    </div>

</template>
<script> 
import serverUtil from "cy_static/serverUtil";
    export default {
        name: 'proModule',
        props: {
            keyId: {// keyId多个以，分隔
                type: String
            },
            drag: {// 阻你系数
            },
            spm: {// data-spm
                type: String
            },
            className: {// 样式名称
                type: String
            },
            url: {// 接口路径
                type: String
            },
            scrollElem: {// 滚动元素
                type: String
            },
            minScrollNum: {// 最大显示多少条记录
                default: 1
            },
            max: {// 最大显示多少条记录
                type: Number,
                default: 100
            },
            baseImgUrl: {
                type: String,
                default: "//m.changyoyo.com/"
            },
            cache: {// data-spm
                type: String
            },
            loginToken: {// data-spm
                type: String
            }
        },
        data: function () {
            return {
                list: []
            }
        },
        mounted (){
            let m = this;
            serverUtil.loadRecommend({
                keyIds: m.keyId || "all",
                login_token : m.loginToken || "",
                cache : m.cache,
                url : m.url || "/pointgate/service/product/newRecommend"
            }, function (keyId, list) {
                if (!list || !list.length) {
                    return;
                }
                var __data = {
                    autoId : ('a' + Math.random()).replace(".", ""),
                    activityName :"",
                    linkUrl :"",
                    data : []
                }
                list = list.slice(0, m.max);
                list.sort(function(a, b) {
                    return b.sort - a.sort;
                })
                list.forEach(function(item, j) {
                    let temamount;
                    item.index = (j + 1);
                    item.topCss = "top_" + item.index;
                    item.coverCss = "l-cover-" + item.storedCount;
                    item._centerPic = m.baseImgUrl + '/'+ item.centerPic;
                    temamount = Number(item.price / 100).toFixed(2).split(".");
                    item.bamount = '<font>' + temamount[0] + '.</font>';
                    item.aamount = '<sub>' + temamount[1] + '</sub>';
                    item.link = '/mall/#/goodsDetail?productId='+ item.productId;
                    item.storedCount < 0 && (item.storedCount = 0);
                    if (item.payType == 'cust' || item.payType == 'cash') {
                        item.priceHtml = '<span>' + (item.bamount + item.aamount) + '<b>元</b></span>';
                        if (item.payType == 'cust') {
                            item.label = "任意积分抵扣";
                            if (item.displayEnable == "01") {
                                item.label = "支持现金购买";
                                item.priceHtml = '<span class="jf">' + item.points + '</span>积分';
                            }
                        }
                    } else if (item.payType == 'comb') {
                        item.priceHtml = '<span class="jf">' + item.points + '</span>积分<span> + ' + (item.bamount + item.aamount) + '</span><b>元</b>';
                    } else {
                        item.priceHtml = '<span class="jf">' + item.points + '</span>积分';
                    }
                })
                __data.data = list;
                __data.activityName = list[0].activityName;
                __data.linkUrl = list[0].linkUrl;
                m.list = m.list.concat(__data);

                if (m.scrollElem && __data.data.length > m.minScrollNum) {
                    setTimeout(function () {
                        m.loadSlider(function () {
                            window.Slider({
                                drag : m.drag ? parseFloat(m.drag): 0.8, 	// 阻尔糸数
                                elem : "#" + __data.autoId, 	// 滑动元素选择器
                                content :"#" + __data.autoId + " " + m.scrollElem, 	// 滚动元素选择器
                                onFinish:function (mumber) {
                                }
                            });
                        })
                    },200)
                }
            })
        },
        methods: {
            loadSlider : function (callback) {
                if (window.Slider) {
                    callback();
                } else {
                    var script = document.createElement("script");
                    script.type = "text/javascript";
                    script.src = "/static/js/common/slider.js";
                    document.getElementsByTagName('head')[0].appendChild(script);
                    script.onload = function() {
                        callback();
                    }
                }
            }
        }
    }
</script>